import { render, staticRenderFns } from "./ImportField.vue?vue&type=template&id=706e4034&"
import script from "./ImportField.vue?vue&type=script&lang=js&"
export * from "./ImportField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports